import {Pageable, PageModel} from "@/api/Paging.ts";
import {Dungeon} from "@/dungeons/model/Dungeon.ts";
import {SaveDungeonBasicsRequest, SaveDungeonGeometryRequest, SaveDungeonRequest} from "@/dungeons/admin/form/DungeonFormSchema.ts";
import {http} from "@/api/HttpClient.ts";

export async function searchDungeons(pageable: Pageable, params?: DungeonFilterParams, signal?: AbortSignal): Promise<PageModel<Dungeon>> {
    const res = await http.get<PageModel<Dungeon>>("/dungeons", {params: {...pageable, ...params}, signal});
    return res.data;
}

export async function getDungeonById(id: string, signal?: AbortSignal): Promise<Dungeon> {
    const res = await http.get<Dungeon>(`/dungeons/${id}`, {signal});
    return res.data;
}

export async function saveDungeon(dungeon: SaveDungeonRequest): Promise<Dungeon> {
    const response = await http.post<Dungeon>(`/dungeons`, dungeon);
    return response.data;
}

export async function saveDungeonBasics(request: SaveDungeonBasicsRequest): Promise<Dungeon> {
    const response = await http.post<Dungeon>("/dungeons/basics", request);
    return response.data;
}

export async function saveDungeonGeometry(id: string, request: SaveDungeonGeometryRequest): Promise<Dungeon> {
    const response = await http.post<Dungeon>(`/dungeons/${id}/geometry`, request);
    return response.data;
}

export async function deleteDungeon(id: string): Promise<void> {
    await http.delete<Dungeon>(`/dungeons/${id}`);
}

export interface DungeonFilterParams {
    name?: string;
}
